var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0246582,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#E4EDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2292 12V6.18182H8.60042V12H7.2292ZM7.9186 5.35606C7.70143 5.35606 7.51456 5.28409 7.35799 5.14015C7.20143 4.99369 7.12314 4.81818 7.12314 4.61364C7.12314 4.40657 7.20143 4.23106 7.35799 4.08712C7.51456 3.94066 7.70143 3.86742 7.9186 3.86742C8.13829 3.86742 8.32516 3.94066 8.4792 4.08712C8.63577 4.23106 8.71405 4.40657 8.71405 4.61364C8.71405 4.81818 8.63577 4.99369 8.4792 5.14015C8.32516 5.28409 8.13829 5.35606 7.9186 5.35606Z",
    fill: "#0C5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.e7de8b39dcc0d46c37ec286b104f0b0f.svg";
export { ForwardRef as ReactComponent };